import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import Page from '../Page';

const memoizedEcmContent = createSelector(
  [(state) => state.ecmContent],
  (ecmContent) => ecmContent
);
const serviceDataSelector = (state) => state.serviceData;

function mapStateToProps(state) {
  return {
    ecmContent: memoizedEcmContent(state),
    serviceData: serviceDataSelector(state)
  };
}

export default connect(mapStateToProps)(Page);
